import React from "react"
import {history} from "../../history";
import {NavLink} from "reactstrap";
import * as Icon from "react-feather";
import {FormattedMessage} from "react-intl";

class Error404 extends React.Component {
    render() {
        return (
            <>
                <div className="position-fixed error-connection">
                    <div className="position-relative box-error-connection">
                        <Icon.AlertOctagon className="mr-4 ml-4" size={100}/>
                        <FormattedMessage id="ErrorOccurred"/>
                        <div>
                            <FormattedMessage id="CheckNet"/>
                        </div>
                        <div>
                            <FormattedMessage id="CallSupport"/>
                        </div>
                        <div className="w-100 d-flex justify-content-center">
                            <NavLink className="mt-5 mb-2 btn btn-light"
                                     href={history.location.pathname + decodeURI(history.location.search)}>
                                <FormattedMessage id="ReloadPage"/>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default Error404;
